import React from "react";
import { useOutletContext } from "react-router-dom";
import { BulkMessageOutletContext } from "./SendBulkMessage";
import { CsvUploadForm } from "./CsvUploadForm";
import { FilterTypeSelection } from "./BasicInformationPage/FilterTypeSelection";
import { BulkMessageSendFilterType } from "./types";

interface CsvUploadProps {
  filterType: BulkMessageSendFilterType;
  setFilterType: React.Dispatch<
    React.SetStateAction<BulkMessageSendFilterType>
  >;
}
export function CsvUpload({ filterType, setFilterType }: CsvUploadProps) {
  const { setLoading, isLoading, setCsvFile, csvFile, isActive } =
    useOutletContext<BulkMessageOutletContext>();

  return (
    <div className="flex flex-col">
      <FilterTypeSelection
        filterType={filterType}
        setFilterType={setFilterType}
        disabled={isActive}
      />
      <CsvUploadForm
        setLoading={setLoading}
        isLoading={isLoading}
        setCsvFile={setCsvFile}
        csvFile={csvFile}
        isActive={isActive}
      />
    </div>
  );
}
